import { SettingsMasterStep, StepIndexSMART, StepIndexZota, } from './type';
export const pathSpecSMART = {
    [StepIndexSMART.first]: {
        title: 'Способ управления котлом',
        child: () => [SettingsMasterStep.DigitalBus, SettingsMasterStep.Relay],
    },
    [StepIndexSMART.second]: {
        title: 'Модель котла',
        child: () => [SettingsMasterStep.BoilerModel],
    },
    [StepIndexSMART.third]: {
        title: 'Тип котла',
        child: () => [
            SettingsMasterStep.GasBoiler,
            SettingsMasterStep.ElectricalBoiler,
        ],
    },
    [StepIndexSMART.fourth]: {
        title: 'Наличие ГВС',
        child: () => [SettingsMasterStep.BoilerDHW, SettingsMasterStep.BoilerNoDHW],
    },
    [StepIndexSMART.fifth]: {
        title: 'Способ получения горячей воды',
        child: () => [
            SettingsMasterStep.SingleCircuit,
            SettingsMasterStep.DoubleCircuit,
        ],
    },
    [StepIndexSMART.sixth]: {
        title: 'Тип управления отоплением',
        child: () => [
            SettingsMasterStep.AirControl,
            SettingsMasterStep.WaterControl,
            SettingsMasterStep.PZAControl,
        ],
    },
    [StepIndexSMART.seventh]: {
        title: 'Режим регулирования теплоносителя',
        child: (path) => {
            if (path.includes(SettingsMasterStep.GasBoiler))
                return [
                    SettingsMasterStep.WithPIDRegulation,
                    SettingsMasterStep.WithoutPIDRegulation,
                ];
            else {
                return [SettingsMasterStep.WithoutPIDRegulation];
            }
        },
    },
    [StepIndexSMART.eighth]: {
        title: 'Погодозависимое управление',
        child: (path) => {
            if (path.includes(SettingsMasterStep.ElectricalBoiler)) {
                return [SettingsMasterStep.OutRoomTemp];
            }
            return [SettingsMasterStep.InRoomTemp, SettingsMasterStep.OutRoomTemp];
        },
    },
    [StepIndexSMART.ninth]: {
        title: 'Сохранить настройки?',
        child: () => [
            SettingsMasterStep.SavedSetting,
            SettingsMasterStep.NoSavedSetting,
        ],
    },
};
export const pathSpecZota = {
    [StepIndexZota.first]: {
        title: 'Модель котла',
        child: () => [SettingsMasterStep.BoilerModel],
    },
    [StepIndexZota.second]: {
        title: 'Способ управления котлом',
        child: () => [SettingsMasterStep.DigitalBus, SettingsMasterStep.Relay],
    },
    [StepIndexZota.third]: {
        title: 'Тип котла',
        child: () => [
            SettingsMasterStep.GasBoiler,
            SettingsMasterStep.ElectricalBoiler,
        ],
    },
    [StepIndexZota.fourth]: {
        title: 'Наличие ГВС',
        child: () => [SettingsMasterStep.BoilerDHW, SettingsMasterStep.BoilerNoDHW],
    },
    [StepIndexZota.fifth]: {
        title: 'Способ получения горячей воды',
        child: () => [
            SettingsMasterStep.SingleCircuit,
            SettingsMasterStep.DoubleCircuit,
        ],
    },
    [StepIndexZota.sixth]: {
        title: 'Тип управления отоплением',
        child: () => [
            SettingsMasterStep.AirControl,
            SettingsMasterStep.WaterControl,
            SettingsMasterStep.PZAControl,
        ],
    },
    [StepIndexZota.seventh]: {
        title: 'Режим регулирования теплоносителя',
        child: (path) => {
            if (path.includes(SettingsMasterStep.GasBoiler))
                return [
                    SettingsMasterStep.WithPIDRegulation,
                    SettingsMasterStep.WithoutPIDRegulation,
                ];
            else
                return [SettingsMasterStep.WithoutPIDRegulation];
        },
    },
    [StepIndexZota.eighth]: {
        title: 'Погодозависимое управление',
        child: (path) => {
            if (path.includes(SettingsMasterStep.ElectricalBoiler)) {
                return [SettingsMasterStep.OutRoomTemp];
            }
            return [SettingsMasterStep.InRoomTemp, SettingsMasterStep.OutRoomTemp];
        },
    },
    [StepIndexZota.ninth]: {
        title: 'Сохранить настройки?',
        child: () => [
            SettingsMasterStep.SavedSetting,
            SettingsMasterStep.NoSavedSetting,
        ],
    },
};
export const pathSpec = {
    SMART: pathSpecSMART,
    Zota: pathSpecZota,
};
